import { app } from '../../../../../../app';
import { Controller } from './regenerate-app-password.controller';

app.component('companyManageApplicationIntegrationDevelopersAppKeyPasswordRegenerate', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./regenerate-app-password.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/app-key-password/regenerate/regenerate-app-password.component.js